import React from 'react';
import { Check, ArrowRight, Clock, Crown, User, Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegacyGrowthMastery = () => {
    return (
        <div className="bg-exiser-light min-h-screen">
            {/* Hero */}
            <div className="bg-gradient-to-br from-exiser-primary to-purple-900 text-white py-16 md:py-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" />
                <div className="max-w-5xl mx-auto px-4 relative z-10">
                    <Link to="/categories" className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 uppercase tracking-wider text-xs font-bold transition-colors">
                        <ArrowLeft className="w-4 h-4" /> Back to Programmes
                    </Link>
                    <div className="inline-flex items-center gap-2 bg-exiser-accent/20 border border-exiser-accent/60 px-3 py-1 rounded-full mb-4">
                        <Crown className="w-4 h-4 text-exiser-accent" />
                        <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-exiser-accent">
                            VIP Transformation
                        </span>
                    </div>
                    <h1 className="text-3xl md:text-5xl font-bold uppercase tracking-tight mb-4">
                        Legacy Growth Mastery
                    </h1>
                    <p className="text-sm md:text-base text-purple-100 max-w-3xl font-sans font-medium italic border-l-4 border-exiser-accent pl-4 py-1 mb-6">
                        "The ultimate 12-month transformation journey where a Life Insurance Advisor becomes a Brand."
                    </p>
                    <p className="text-sm md:text-base text-purple-100 max-w-3xl font-sans leading-relaxed">
                        A comprehensive 1-year ecosystem to master sales, build authority, and leave a lasting legacy in the financial industry.
                    </p>

                    <div className="mt-6 flex flex-wrap items-center gap-4 text-xs uppercase tracking-[0.2em]">
                        <div className="flex items-center gap-2">
                            <Clock className="w-4 h-4" />
                            <span>Duration: 12 Months</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <User className="w-4 h-4" />
                            <span>For: Advisors / Financial Planners</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Shield className="w-4 h-4" />
                            <span>By Application Only</span>
                        </div>
                    </div>

                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link
                            to="/categories#legacy-growth-mastery"
                            className="inline-flex items-center gap-2 bg-exiser-accent text-exiser-primary px-6 py-3 text-xs font-bold uppercase tracking-[0.22em] rounded-lg hover:bg-white shadow-lg"
                        >
                            Request Application
                            <ArrowRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-5xl mx-auto px-4 py-12 md:py-16 space-y-12">
                <section className="bg-white rounded-2xl shadow-xl border border-purple-100 p-8">
                    <h2 className="text-xl md:text-2xl font-bold uppercase text-exiser-primary mb-6">
                        Why This Program?
                    </h2>
                    <p className="text-gray-600 font-sans mb-4">
                        Many advisors struggle to scale beyond a certain point. They remain "agents" instead of becoming "authorities". This program bridges that gap.
                    </p>
                    <ul className="space-y-3 text-sm text-gray-700 font-sans">
                        <li className="flex gap-2"><Check className="w-4 h-4 text-green-600 mt-0.5" /> Transform from salesperson to trusted consultant.</li>
                        <li className="flex gap-2"><Check className="w-4 h-4 text-green-600 mt-0.5" /> Build a personal brand that attracts high-net-worth clients.</li>
                        <li className="flex gap-2"><Check className="w-4 h-4 text-green-600 mt-0.5" /> Create systems for consistent, predictable revenue.</li>
                        <li className="flex gap-2"><Check className="w-4 h-4 text-green-600 mt-0.5" /> Master the psychology of wealth and influence.</li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default LegacyGrowthMastery;
